<script setup>
import { useConfig } from "@/app/composables/useConfig"
import { router } from "@/app/router"
import { computed, watch } from "vue"
import { capitalizeString } from "../shared/helpers/general.helper"
import SimplePage from "./SimplePage.vue"

const brandName = computed(() => capitalizeString(import.meta.env.VITE_APP_BRAND))

const { geoblocked } = useConfig()

watch(() => geoblocked.value, (newValue) => {
  if (!newValue) {
    router.push({ path: "/" })
  }
})
</script>

<template>
  <SimplePage
    title="Your Region is Geo-Blocked :("
    :body="`You have accessed ${brandName} from a region that is prohibited under our Licencing agreement.`"
    suffix="Are you using a VPN or proxy? If so, try turning it off and refresh the page to be able to login."
    :show-back-button="true"
  />
</template>

<style scoped></style>
